// extracted by mini-css-extract-plugin
module.exports = {"root":"UploadDropzone_root__yAvhv","placeholder":"UploadDropzone_placeholder__30ohJ"};